import { sheetScope } from "../utils/props";

export const stackScope = /*           */ sheetScope.scope("stack");

/**
 *
 *
 *
 *
 */
export const findInstance = (
  sheetId: string | null | undefined,
  container: HTMLElement | Document = document,
): HTMLOcSheetV1Element | null =>
  sheetId ? container.querySelector<HTMLOcSheetV1Element>(`#${sheetId}`) : null;

/**
 *
 *
 *
 */
export const getInstance = (sheetId: string): HTMLOcSheetV1Element =>
  findInstance(sheetId) ??
  (() => {
    throw new Error(`Sheet instance with id ${sheetId} not found in the DOM.`);
  })();
